import axios from 'axios';
import { showSessionExpiredModal } from '../utils/sessionExpired';

// Base URLs are environment-driven. CRA loads, in order:
//   .env                 (baseline, committed)
//   .env.development     (overrides for `npm start` — points to QA)
//   .env.production      (overrides for `npm run build` — points to prod)
// and any process-level REACT_APP_* env vars win over all files.
//
// Fallbacks below are intentionally QA so a missing env file fails "safely"
// toward non-prod rather than pointing an unconfigured build at production.
export const BASEURL =
    process.env.REACT_APP_BASE_URL ||
    "https://prod-new.allcityapp.com/actdispatcher/";

export const ADMIN_BASEURL =
    process.env.REACT_APP_ADMIN_BASE_URL ||
    "https://prod-new.allcityapp.com/actadmin/";

// Shared URL classifier. Used by the 401 interceptor below AND by the pre-call
// expiry guard in useServices.js, so both speak the same language.
//
// Call sites are inconsistent — some pass `ars/directCall/...` and some pass
// `/ars/directCall/...`. Axios stores the relative path verbatim in
// `config.url` (baseURL is not prepended), so naive `.includes('/ars/')`
// silently misses the no-slash form. Normalize first.
//
// Auth-issuance endpoints (/issueToken, /validatePassphrase, /validateAccLink/)
// are excluded: a 401 there means "bad link/passphrase", not "kick the user
// out of a live session", and the screen-level handler shows the right error.
export const isArsAuthRequiredCall = (url) => {
    if (!url) return false;
    const n = url.startsWith('/') ? url : '/' + url;
    if (!n.includes('/ars/')) return false;
    if (n.includes('/issueToken')) return false;
    if (n.includes('/validatePassphrase')) return false;
    if (n.includes('/validateAccLink/')) return false;
    return true;
};

const instance = axios.create({
    baseURL: `${BASEURL}`
});

// Global 401 → kick-out. Catches every call through this instance, including
// direct `axiosInstance({...})` invocations (e.g. mfaService.js) that bypass
// the useServices wrappers. The error is re-thrown so per-call catch blocks
// still see the failure and can render their own UI underneath the modal.
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error && error.response && error.response.status === 401) {
            const url = (error.config && error.config.url) || '';
            if (isArsAuthRequiredCall(url)) {
                showSessionExpiredModal();
            }
        }
        return Promise.reject(error);
    }
);

export default instance;
